import * as React from "react";
import {useCartContext} from "../../../../cart/CartContextProvider/CartContextProvider";
import {PurchaseButtonProps} from "./PurchaseButtonProps";
import DefaultPurchaseButton from "./DefaultPurchaseButton";
import {useCustomerSelector} from "../../../../../store";

/* PAYPAL EXPRESS */
const PaypalExpressPurchaseButton: React.FC<PurchaseButtonProps> = ({purchaseButtonErrors}) => {
  const {customer} = useCustomerSelector();

  const {paypalInfos} = useCartContext().viewState;

  return (
    <DefaultPurchaseButton
      purchaseButtonErrors={purchaseButtonErrors}
      paymentInfos={paypalInfos}
      visitorId={customer.visitorId}
      occurrence="Paypal Express Summary Purchase Button"
    />
  );
};

export default PaypalExpressPurchaseButton;
